/**
 * @file automatically generated from MApp.Spatial.Axis
 */

export enum Axis {
    North = 0,
    East = 1,
    West = 2,
    South = 3,
    NorthWest = 4,
    NorthEast = 5,
    EastSouthEast = 6,
    NorthNorthEast = 7,
    NorthNorthWest = 8,
    WestSouthWest = 9,
    Up = 10,
    Down = 11,
    GeocentricX = 12,
    GeocentricY = 13,
    GeocentricZ = 14,
    Starboard = 15,
    Ahead = 16,
    Upward = 17
}
